import React from 'react';
import { ActivityIcon, HeartIcon, BedIcon, DropletIcon, ArrowRightIcon } from 'lucide-react';
export const BioAgeAnalyzer: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-157">
      <div className="mb-6" data-id="element-158">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-159">BioAge Analyzer</h1>
        <p className="text-gray-600" data-id="element-160">Verstehe dein biologisches Alter</p>
      </div>
      {/* Main BioAge Display */}
      <section className="mb-8 bg-white rounded-xl shadow-sm p-6 text-center" data-id="element-161">
        <h2 className="text-lg font-semibold text-gray-700 mb-2" data-id="element-162">
          Dein biologisches Alter
        </h2>
        <div className="relative inline-block" data-id="element-163">
          <div className="w-48 h-48 rounded-full border-8 border-purple-100 flex items-center justify-center mb-4 mx-auto" data-id="element-164">
            <div className="text-center" data-id="element-165">
              <span className="text-5xl font-bold text-purple-600" data-id="element-166">32.4</span>
              <p className="text-gray-500" data-id="element-167">Jahre</p>
            </div>
          </div>
          <div className="absolute -top-2 -right-2 bg-green-100 text-green-600 rounded-full px-3 py-1 text-sm font-medium" data-id="element-168">
            -2.6 Jahre
          </div>
        </div>
        <p className="text-gray-600 mb-4" data-id="element-169">
          Dein chronologisches Alter: 35 Jahre
        </p>
        <div className="flex justify-center space-x-6" data-id="element-170">
          <div data-id="element-171">
            <p className="text-sm text-gray-500" data-id="element-172">Vor 3 Monaten</p>
            <p className="font-semibold text-gray-700" data-id="element-173">33.1 Jahre</p>
          </div>
          <div data-id="element-174">
            <p className="text-sm text-gray-500" data-id="element-175">Aktuell</p>
            <p className="font-semibold text-purple-600" data-id="element-176">32.4 Jahre</p>
          </div>
          <div data-id="element-177">
            <p className="text-sm text-gray-500" data-id="element-178">Prognose</p>
            <p className="font-semibold text-green-600" data-id="element-179">31.8 Jahre</p>
          </div>
        </div>
      </section>
      {/* Key Metrics */}
      <section className="mb-8" data-id="element-180">
        <div className="flex justify-between items-center mb-4" data-id="element-181">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-182">
            Einflussfaktoren
          </h2>
          <button className="text-purple-600 flex items-center text-sm font-medium" data-id="element-183">
            Details <ArrowRightIcon size={16} className="ml-1" data-id="element-184" />
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-185">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-186">
            <div className="flex items-center mb-3" data-id="element-187">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-188">
                <HeartIcon size={20} className="text-red-600" data-id="element-189" />
              </div>
              <div data-id="element-190">
                <p className="font-medium text-gray-800" data-id="element-191">
                  Herzfrequenzvariabilität
                </p>
                <p className="text-sm text-gray-500" data-id="element-192">
                  Beeinflusst dein BioAge um +0.8 Jahre
                </p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-193">
              <div className="bg-red-500 h-2 rounded-full" style={{
              width: '65%'
            }} data-id="element-194"></div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-195">
            <div className="flex items-center mb-3" data-id="element-196">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-197">
                <BedIcon size={20} className="text-blue-600" data-id="element-198" />
              </div>
              <div data-id="element-199">
                <p className="font-medium text-gray-800" data-id="element-200">Schlafqualität</p>
                <p className="text-sm text-gray-500" data-id="element-201">
                  Beeinflusst dein BioAge um +0.5 Jahre
                </p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-202">
              <div className="bg-blue-500 h-2 rounded-full" style={{
              width: '70%'
            }} data-id="element-203"></div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-204">
            <div className="flex items-center mb-3" data-id="element-205">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-206">
                <div size={20} className="text-green-600" data-id="element-207" />
              </div>
              <div data-id="element-208">
                <p className="font-medium text-gray-800" data-id="element-209">Tägliche Aktivität</p>
                <p className="text-sm text-gray-500" data-id="element-210">
                  Beeinflusst dein BioAge um -1.2 Jahre
                </p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-211">
              <div className="bg-green-500 h-2 rounded-full" style={{
              width: '85%'
            }} data-id="element-212"></div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-213">
            <div className="flex items-center mb-3" data-id="element-214">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-215">
                <DropletIcon size={20} className="text-purple-600" data-id="element-216" />
              </div>
              <div data-id="element-217">
                <p className="font-medium text-gray-800" data-id="element-218">
                  Hydration & Ernährung
                </p>
                <p className="text-sm text-gray-500" data-id="element-219">
                  Beeinflusst dein BioAge um -0.7 Jahre
                </p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-220">
              <div className="bg-purple-500 h-2 rounded-full" style={{
              width: '80%'
            }} data-id="element-221"></div>
            </div>
          </div>
        </div>
      </section>
      {/* Connect Device */}
      <section className="mb-8" data-id="element-222">
        <div className="bg-purple-50 rounded-xl p-4 flex items-center justify-between" data-id="element-223">
          <div className="flex items-center" data-id="element-224">
            <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mr-4" data-id="element-225">
              <ActivityIcon size={24} className="text-purple-600" data-id="element-226" />
            </div>
            <div data-id="element-227">
              <p className="font-medium text-gray-800" data-id="element-228">
                Verbinde deine Fitnessuhr
              </p>
              <p className="text-sm text-gray-600" data-id="element-229">
                Für genauere BioAge-Analysen
              </p>
            </div>
          </div>
          <button className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium" data-id="element-230">
            Verbinden
          </button>
        </div>
      </section>
    </div>;
};